import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function Pencil({ width = 13, color }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={width}
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 10.5V13H2.5L9.87333 5.62662L7.37333 3.12662L0 10.5ZM11.8067 3.69329C12.0667 3.43329 12.0667 3.01329 11.8067 2.75329L10.2467 1.19329C9.98667 0.933291 9.56667 0.933291 9.30667 1.19329L8.08667 2.41329L10.5867 4.91329L11.8067 3.69329Z'
        fill={color || theme.colors.white100}
      />
    </svg>
  );
}
